import axios, { AxiosError } from 'axios';

import { HttpRequestInterceptors } from '@/common/utils/httpRequestInterceptors';
import { HttpResponseErrorsInterceptors } from '@/common/utils/httpResponseErrorsInterceptors';

import { ENV } from './env';

export const httpClient = axios.create({
  baseURL: ENV.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

httpClient.interceptors.request.use(config => {
  return new HttpRequestInterceptors(config)
    .stringifyParams()
    .setLanguageHeader()
    .setAccountIdHeader()
    .build();
});

httpClient.interceptors.response.use(
  response => response,
  async error => {
    if (error instanceof AxiosError) {
      return Promise.reject(
        new HttpResponseErrorsInterceptors(error).disconnectUser().build(),
      );
    }

    return Promise.reject(error);
  },
);
